import { DISCONNECT_ACC, FETCH_ACCOUNTS, FETCH_PERSONAL_ACCOUNT, SET_ACCOUNT_FEED } from "./keys"

const initialState = { connectedAcc: null, selectedAccount: null, personalAccount: null }

export default function reducer(state = initialState, action) {

    switch (action.type) {
        case FETCH_ACCOUNTS: {
            return { ...state, connectedAcc: action.payload }
        }

        case FETCH_PERSONAL_ACCOUNT: {
            return { ...state, personalAccount: action.payload }
        }

        case DISCONNECT_ACC: {
            var cAcc = state.connectedAcc
            cAcc = cAcc.filter(acc => acc.ConnectedAccounts.id != action.payload)
            if (cAcc.length == 0) cAcc = []
            return { ...state, connectedAcc: cAcc }
        }

        case SET_ACCOUNT_FEED: {
            return { ...state, selectedAccount: action.payload }
        }

        default:
            return { ...state }
    }

}


